<template>
  <div class="user-detail-container">
    <div class="menu-data">
      <el-menu
        :default-active="active"
        popper-class="menu-data-nav"
        default-openeds="[1]"
        @select="selectmenu"
      >
        <el-submenu index="1">
          <template #title>
            <span><i class="el-icon-user-solid"></i>个人中心</span>
          </template>
          <el-menu-item index="1-1">
            <span>个人资料</span>
          </el-menu-item>
          <el-menu-item index="1-2">
            <span>我的应用</span>
          </el-menu-item>
          <el-menu-item index="1-3">
            <span>我的申请</span>
          </el-menu-item>
          <el-menu-item index="1-4">
            <span>我的收藏</span>
          </el-menu-item>
        </el-submenu>
      </el-menu>
    </div>

    <div class="data-info">
      <div v-if="path == '1-1'">
        <el-form
          ref="form"
          v-if="userInfo"
          :model="userInfo"
          label-width="150px"
        >
          <el-form-item label="类别">
            {{ userInfo.orgName ? "法人" : "个人" }}
          </el-form-item>

          <el-form-item label="姓名">
            {{ userInfo.name }}
          </el-form-item>

          <el-form-item label="账号">
            {{ userInfo.accountName }}
          </el-form-item>

          <el-form-item label="邮箱">
            {{ userInfo.email }}
          </el-form-item>

          <el-form-item label="民族">
            {{ userInfo.nationName }}
          </el-form-item>

          <el-form-item label="性别">
            {{ userInfo.sexName }}
          </el-form-item>

          <el-form-item v-if="userInfo.orgName" label="企业法人名称">
            {{ userInfo.orgName }}
          </el-form-item>

          <el-form-item v-if="userInfo.orgName" label="统一信用代码">
            {{ userInfo.uscCode }}
          </el-form-item>

          <el-form-item v-if="userInfo.orgName" label="工商注册号码">
            {{ userInfo.registCode }}
          </el-form-item>

          <el-form-item label="认证级别">
            {{ userInfo.certificationLevelName }}
          </el-form-item>
        </el-form>
      </div>
      <div v-if="path == '1-2'">
        <app />
      </div>
      <div v-if="path == '1-3'">
        <apply-list
          :hasApply="hasApply"
          @changeHasApply="changeHasApply"
          :dataset="dataset"
          :iface="iface"
        />
      </div>
      <div v-if="path == '1-4'">
        <collect-list />
      </div>
    </div>
  </div>
</template>
<script>
import store from "@/store";
import { getUserInfos } from "@/utils/accessToken";
import app from "./components/app";
import applyList from "./components/applyList";
import collectList from "./components/collectList";

export default {
  components: {
    app,
    applyList,
    collectList
  },
  data() {
    return {
      active: "1-1",
      title: "1.1平台简介",
      path: "1-1",
      userInfo: getUserInfos(),
      hasApply: false,
      dataset: "",
      iface: ""
    };
  },
  created() {
    if (this.$route.query.dataset && this.$route.query.iface) {
      this.hasApply = true;
      this.path = this.active = "1-3";
      this.dataset = this.$route.query.dataset;
      this.iface = this.$route.query.iface;
      this.$router.push({ query: {} });
    }
    this.init();
  },
  methods: {
    changeHasApply(hasApply) {
      this.hasApply = hasApply;
    },
    selectmenu(e) {
      this.path = e;
      switch (e) {
        case "1-2":
          break;
        case "1-3":
          this.hasApply = false;
          break;
        case "1-4":
          break;
        default:
          break;
      }
    },

    async init() {
      this.userInfo = JSON.parse(store.getters["user/userInfo"]);
    }
  }
};
</script>
<style lang="scss" scoped>
.el-table >>> .header-row th {
  background: rgb(240, 240, 240) !important;
}
.user-detail-container {
  width: 1200px;
  margin-bottom: 130px;
  display: flex;
  flex-direction: row;
  .data-info {
    padding: 20px 15px;
    width: 980px;
    background: #ffffff;
    margin-left: 15px;
    min-height: 500px;
    .title {
      font-size: 14px;
      font-weight: 500;
      color: #333333;
      line-height: 36px;
      width: 100%;
      border-bottom: 1px solid #dddddd;
    }
    .content {
      padding: 20px 15px;
    }
  }
  .menu-data {
    .user-avatar {
      width: 210px;
      height: 210px;
      background: #e0e0e0;
      border: 1px solid #eeeeee;
      margin-bottom: 15px;
    }
    min-height: 1000px;
    /deep/.el-menu {
      width: 210px;
      border: 1px solid #eeeeee;
    }
    .el-submenu /deep/ .el-submenu__title {
      background: #2a7ee3 !important;
      font-size: 16px;
      font-weight: 400;
      color: #ffffff !important;
    }
    .el-submenu /deep/ .el-submenu__title:last-child {
      background: #999999 !important;
      font-size: 16px;
      font-weight: 400;
      color: #ffffff !important;
    }
    .el-submenu /deep/ .el-submenu__title .el-submenu__icon-arrow {
      // border-radius: 50%;
      // border: 1px solid #8bc0ff;
      // padding: 2px
      &::before {
        content: "";
      }
    }
    /deep/ .el-menu-item {
      padding-left: 50px !important;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-content: center;
    }
  }
}
</style>
